import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

function parseApiResponse(raw) {
  let d = raw
  if (typeof d === 'string') {
    try {
      d = JSON.parse(d)
    } catch {
      return raw
    }
  }
  if (d?.body != null) {
    if (typeof d.body === 'string') {
      try {
        return JSON.parse(d.body)
      } catch {
        return d.body
      }
    }
    return d.body
  }
  return d
}

function isApiSuccess(responseData) {
  if (!responseData || typeof responseData !== 'object') return false
  const s = responseData.success
  return s === true || s === 'true' || s === 1 || s === '1'
}

function pickPdfFields(source) {
  if (!source || typeof source !== 'object') {
    return { pdfLink: '', pdfDownloadUrl: '' }
  }
  return {
    pdfLink: String(source.pdfLink || '').trim(),
    pdfDownloadUrl: String(source.pdfDownloadUrl || '').trim()
  }
}

export function extractSoPdfFieldsFromResponse(responseData) {
  const data = responseData?.data
  if (!data || typeof data !== 'object') return { pdfLink: '', pdfDownloadUrl: '' }
  if (data.salesOrder && typeof data.salesOrder === 'object') {
    return pickPdfFields(data.salesOrder)
  }
  if (data.order && typeof data.order === 'object') {
    return pickPdfFields(data.order)
  }
  return pickPdfFields(data)
}

export function hasSalesOrderPdf(source) {
  const { pdfLink } = pickPdfFields(source)
  return Boolean(pdfLink)
}

/**
 * Resolve a browser-usable PDF URL for a sales order.
 * Prefers pdfDownloadUrl; otherwise requests a GetObject-style presign.
 */
export async function resolveSoPdfDownloadUrl({
  pdfDownloadUrl,
  pdfLink,
  salesOrderId,
  currentUserId
}) {
  const signedUrl = String(pdfDownloadUrl || '').trim()
  if (signedUrl) return signedUrl

  if (!String(pdfLink || '').trim()) return ''
  if (!salesOrderId) {
    throw new Error('Sales order ID is required to fetch PDF download URL')
  }

  const response = await axios.post(API_URL, {
    action: 'get-so-pdf-download-presigned-url',
    id: salesOrderId,
    currentUserId: currentUserId || undefined
  })
  const responseData = parseApiResponse(response.data)

  if (!isApiSuccess(responseData)) {
    throw new Error(responseData?.message || 'Failed to get PDF download URL')
  }

  const fromData = extractSoPdfFieldsFromResponse(responseData)
  const downloadUrl =
    fromData.pdfDownloadUrl ||
    String(
      responseData.pdfDownloadUrl ||
        responseData.downloadUrl ||
        responseData.url ||
        ''
    ).trim()

  if (!downloadUrl) {
    // Some backends return a ready public/signed link as pdfLink itself
    const asLink = String(pdfLink || '').trim()
    if (/^https?:\/\//i.test(asLink)) return asLink
    throw new Error('PDF download URL not available')
  }

  return downloadUrl
}
